import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { PrimaryButtonComponent } from '../../basic/buttons/primary-button/primary-button.component';
import { ResumeService } from '../../core/resume/resume.service';
import { SessionTemplate } from '../../core/session-template/session-template';
import { SessionService } from '../../core/session/session.service';
import { WorkspaceHolderService } from '../../core/workspace/workspace.holder.service';
import { ProfileCardComponent } from '../../domain/profile-card/profile-card.component';
import { SalesCycleBarComponent } from '../../domain/sales-cycle/sales-cycle-bar/sales-cycle-bar.component';
import { NewSurveySessionTemplateComponent } from '../../domain/session-template/new-survey-session-template/new-survey-session-template.component';
import { SessionTemplateCardComponent } from '../../domain/session-template/session-template-card/session-template-card.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';
import { SessionTemplateService } from './../../core/session-template/session.template.service';
import { NewEditSessionTemplateComponent } from './../../domain/session-template/new-edit-session-template/new-edit-session-template.component';

@Component({
  selector: 'app-scenario-library',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    MatTooltipModule,
    NzButtonModule,
    NzTagModule,
    NzSkeletonModule,

    BasicPageComponent,
    ProfileCardComponent,
    NewEditSessionTemplateComponent,
    PrimaryButtonComponent,
    NewSurveySessionTemplateComponent,
    SessionTemplateCardComponent,
    SalesCycleBarComponent,
  ],
  templateUrl: './scenario-library.component.html',
  styleUrl: './scenario-library.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScenarioLibraryComponent {
  isLoading = true;

  resumeList = toSignal(this.resumeService.resumeList$(), { initialValue: [] });
  sessionTemplateList = toSignal(this.sessionTemplateService.itemList$(), { initialValue: [] });

  filteredSessionTemplateList = computed(() => {
    const list = this.sessionTemplateList();
    const salesCycle = this.workspaceHolderService.currentSalesCycle();
    const workspace = this.workspaceHolderService.currentWorkspace();

    if (!workspace.settings?.salesCycleList || workspace.settings!.salesCycleList.length === 0) {
      return list;
    }

    const firstSalesCycleId = workspace.settings!.salesCycleList[0].id;

    if (!salesCycle) {
      return list;
    }

    return list.filter((sessionTemplate) => {
      if (salesCycle.id === firstSalesCycleId && !sessionTemplate.unsafeSubData?.salesCycleId) {
        return true;
      }
      return sessionTemplate.unsafeSubData?.salesCycleId === salesCycle.id;
    });
  });

  isSessionTemplateVisible = false;
  isNewSessionTemplateVisible = false;

  sessionTemplate?: SessionTemplate;

  constructor(
    private router: Router,
    private sessionService: SessionService,
    private resumeService: ResumeService,
    private sessionTemplateService: SessionTemplateService,
    private workspaceHolderService: WorkspaceHolderService
  ) {}

  getResume = (id?: string) => computed(() => this.resumeList().find((resume) => resume.id === id));

  onStartNewCallClick() {
    this.isNewSessionTemplateVisible = true;
    // const sessionTemplateUnsafeSubData: SessionTemplateUnSafeSubData = {
    //   language: 'en',

    //   performance: SessionPerformance.Quality, // Hardcode Quality
    //   creativity: SessionCreativity.Creative,
    // };

    // this.sessionTemplateService
    //   .add$('Default Scenario', sessionTemplateUnsafeSubData)
    //   .pipe(take(1))
    //   .subscribe((sessionTemplate) => {
    //     const sessionSubData = {
    //       ...sessionTemplateUnsafeSubData,
    //     };

    //     this.sessionService
    //       .addSession$(sessionTemplate.id)
    //       .pipe(take(1))
    //       .subscribe((data) => {
    //         this.sessionService
    //           .launchSession$(data)
    //           .pipe(take(1))
    //           .subscribe(() => {
    //             this.router.navigate(['', 'practice', data.id]);
    //           });
    //       });
    //   });
  }
}
